export const colors = {
  blue: {
    primary: "#00A1FC",
    secondary: "#0153B5",
  },
  ligth: {
    primary: "#F8F9FA",
    secondary: "#dfdfdf"
  },
  dark: {
    primary: "#212529",
    secondary: "#121214",
  },
  grey: {
    primary: "#dedede",
    secondary: "#343B41",
  },
  danger: {
    primary: "#E83F5B",
    secondary: "#87000a"
  },
  success: {
    primary: "#3FE864",
    secondary: "#00870d"
  },
};
